import RejectConfirmModal from './reject-confirm-modal';

export default RejectConfirmModal;
